import { Pipe, PipeTransform } from "@angular/core";
import { FormArray, FormControl, Validators } from "@angular/forms";

@Pipe({
  name: "isRequired",
  standalone: true,
  // Impure: het verplicht-sterretje moet reageren wanneer Validators.required dynamisch
  // wordt toegevoegd/verwijderd (bv. via setRequired). Bij een pure pipe wijzigt de
  // control-referentie niet, waardoor het sterretje niet zou updaten.
  pure: false,
})
export class IsRequiredPipe implements PipeTransform {
  transform(control: FormControl | FormArray): boolean {
    if (control) return control.hasValidator(Validators.required);
    return false;
  }
}
